import React, {Component} from 'react';

class SimpleLoader extends Component {
  state = {
    loaded: false
  };

  componentDidMount() {
    const {onLoad} = this.props;

    // Run component mounting function
    if (typeof onLoad === "function") {
      onLoad();
    }

    this.setState({loaded: true});
  }

  render() {
    const {loaded} = this.state;
    const {children} = this.props;

    return loaded ? (<React.Fragment>{children}</React.Fragment>) : null;
  }
}

export default SimpleLoader;



// WEBPACK FOOTER //
// ./src/components/SimpleLoader/index.js